'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var accordion = require('../components/accordion.js');
var scrollableTabs = require('../components/scrollable-tabs.js');

var classNames = {
	fuelInfoButton: 'specs-detail-page__section__content__fuel-info__button',
	emissionStandardWarningButton: 'specs-detail-page__section__content__emission-standard__warning-button',
	chargeTimesSelect: 'section__content__charge-times__select',
	chargeTimesInfo: 'section__content__charge-times__info',
	specsDetailPage: 'specs-detail-page'
};

var modifierNames = {
	selected: 'selected'
};

function toggleModalOnClick(buttonClassName, modalId) {
    $.findByBem(buttonClassName).on('click', function(e) {
        e.preventDefault();
        var $modal =  $('#' + modalId);
        $modal.foundation('reveal', 'close');
    });
}

function initChargeTimes () {
	var $chargeTimesSelect = $.findByBem(classNames.specsDetailPage, classNames.chargeTimesSelect);
	var $chargeTimesItems = $.findByBem(classNames.specsDetailPage, classNames.chargeTimesInfo);
	$chargeTimesSelect.off('change.chargeTimes').on('change.chargeTimes', function() {
		var selectedVal = $chargeTimesSelect.val();
		$chargeTimesItems.removeBemClass(classNames.specsDetailPage, classNames.chargeTimesInfo, modifierNames.selected);

		$chargeTimesItems.filterByBem(classNames.specsDetailPage, classNames.chargeTimesInfo, selectedVal)
			.addBemClass(classNames.specsDetailPage, classNames.chargeTimesInfo, modifierNames.selected);
	});
}

basePage.init = function() {
	basePage.initBasePage();
	
	accordion.init();
	scrollableTabs.init();

	toggleModalOnClick(classNames.fuelInfoButton, 'fuelInfo');
	toggleModalOnClick(classNames.emissionStandardWarningButton, 'emissionStandardWarning');

	initChargeTimes();
};

module.exports = basePage;